import AppContext from "PFApp/app_context";
import FiltersBox from "PFApp/components/filters/filters_box";
import FiltersButton from "PFApp/components/filters/filters_button";
import FiltersPreview from "PFApp/components/filters/filters_preview";
import { SavedViewsContextProvider } from "PFApp/components/filters/saved_views_context/saved_views_context";
import AvailableMinutesRangeItem from "PFApp/components/order/available_minutes_range_item";
import { getAPIFilters, getValueFilters } from "PFApp/use_filtered_collection";
import { useDeterministicStringify } from "PFCore/helpers/use_deterministic_stringity";
import { OrderOption } from "PFTypes";
import { PageTarget } from "PFTypes/saved_filters";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Tabs from "../tabs";
import css from "./planner_controls.module.scss";

const viewsKey = PageTarget.WorkflowPlanner;

const PlannerControls = () => {
  const {
    store: {
      pages: {
        workflowPage: {
          planner: { data, loading, updateFilter, setSelectedOrder, resetFilters, noFiltersSelected }
        }
      }
    }
  } = useContext(AppContext);
  const stringify = useDeterministicStringify();
  const { t } = useTranslation("workflow", { keyPrefix: "parts.planner" });

  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    noFiltersSelected && setShowFilters(true);
  }, [noFiltersSelected]);

  const blockedFilters = ["term", "state", "availability"];

  if (!data?.meta) {
    return null;
  }

  const { meta } = data;

  return (
    <SavedViewsContextProvider viewsKey={viewsKey}>
      <div className={css.header}>
        <Tabs />
        <div className={css.controls}>
          <FiltersButton
            filtersAreClear={noFiltersSelected}
            onClick={() => (noFiltersSelected ? null : setShowFilters((prev) => !prev))}
            withLabel
          />
        </div>
        {showFilters && (
          <div className={css.filters}>
            <FiltersBox
              style={{ position: "relative", width: "100%" }}
              blockedList={blockedFilters}
              isLoading={loading}
              meta={meta}
              handleFilterChange={updateFilter}
              handleFiltersChange={resetFilters}
              clearFilters={resetFilters}
              filtersAreClear={noFiltersSelected}
              closeFilters={() => setShowFilters(false)}
              clearRefValue={stringify(getAPIFilters(getValueFilters(meta.filters)))}
              allowToClose={!noFiltersSelected}
              viewsKey={viewsKey}
            >
              {noFiltersSelected ? (
                <div style={{ margin: "0 30px", padding: "20px 10px 10px 10px" }}>
                  {t("selectFilterToStart")}
                </div>
              ) : (
                <AvailableMinutesRangeItem
                  style={{ margin: "0 30px", padding: "20px 10px" }}
                  order={{ ...meta.order, title: "Most available in" }}
                  handleChange={({ start_date, end_date }) => {
                    setSelectedOrder({ ...meta.order?.value, start_date, end_date } as OrderOption);
                  }}
                />
              )}
            </FiltersBox>
          </div>
        )}
      </div>
      {!noFiltersSelected && (
        <>
          <div className={css.preview}>
            {!showFilters && (
              <div className={css.availabilityWrapper}>
                <AvailableMinutesRangeItem
                  order={{ ...meta.order, title: t("mostAvailableIn") }}
                  popperOptions={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [100, 15]
                        }
                      }
                    ]
                  }}
                  handleChange={({ start_date, end_date }) => {
                    setSelectedOrder({ ...meta.order?.value, start_date, end_date } as OrderOption);
                  }}
                />
              </div>
            )}
            <div className={css.filtersPreview}>
              <FiltersPreview
                meta={meta}
                viewsKey={viewsKey}
                blockedList={blockedFilters}
                filtersAreClear={noFiltersSelected}
                clearFilters={() => resetFilters({})}
                onFilterChange={updateFilter}
                onMoreClicked={() => setShowFilters(true)}
              />
            </div>
          </div>
        </>
      )}
    </SavedViewsContextProvider>
  );
};

export default PlannerControls;
